import React, {Component} from 'react';
import LoginForm from './LoginForm';

class LoginPage extends Component{
  render() {
    return (
      <div className="page-dark">
          <LoginForm />
      </div>
    );
  }
}

export default LoginPage;




// WEBPACK FOOTER //
// ./src/components/login/LoginPage.js